import template from './asset-list-view.html';
import { cloneDeep } from 'lodash-es';

class AssetListViewController {
  constructor($timeout) {
    'ngInject';

    this.onSortChange = this.onSortChange.bind(this);
    this.currentPage = 1;
    this.pagedAssets = [];
    this.$timeout = $timeout;

    this.setPage = (pageNum = null) => {
      if (pageNum !== null) this.currentPage = pageNum;

      const begin = (this.currentPage - 1) * this.itemsPerPage;
      const end = begin + this.itemsPerPage;
      this.pagedAssets = this.assets.slice(begin, end);
    };
  }

  $onInit() {
    this.itemsPerPage = this.itemsPerPage || 15;
  }

  $onChanges(changes) {
    const { assets } = changes;

    if (assets) {
      //needed the deep clone for the ng repeat in the table to redraw if the changes only in the inner object.
      this.assets = cloneDeep(assets.currentValue || []);
      this.setPage(1);
    }
  }

  onSortChange(column) {
    this.sortCol = column;
    if (typeof column.ascending !== 'boolean') {
      this.columnsDef.forEach((col) => {
        if (col.field !== column.field && typeof col.ascending === 'boolean')
          col.ascending = undefined;
      });
    }

    column.ascending = !column.ascending;

    this.sortList(column);
    this.setPage();
  }

  sortList(column) {
    if (typeof column === 'undefined') {
      column = this.columnsDef.find((column) => typeof column.ascending === 'boolean');
    }

    this.assets = this.assets.sort(column.sort);
  }
}

export default {
  template,
  controller: AssetListViewController,
  controllerAs: 'alVm',
  bindings: {
    assets: '<',
    columnsDef: '<',
    searchString: '<',
    itemsPerPage: '<',
    onItemClick:'<',
  },
};
